<template>
    <div class="page-device-statistic xc-modal xc-modal-page">
        <div class="xc-modal-wrap">
            <div class="xc-modal-content">
                <div class="xc-modal-header">
                    <div class="xc-modal-title">上线日志-{{type==1?'5个节目以下的终端数':type==2?'5-10个节目的终端数':type==3?'10个节目以上的终端数':type}}</div>
                    <div
                        class="xc-modal-close"
                        @click="layerClose"
                    ></div>
                </div>
                <div class="xc-modal-body">
                    <div class="xc-form-inline">

                        <template v-if="type == '近期未上线终端'">
                            <xc-form-item
                                label="时间"
                                required
                                :error="errors.first('startTime','value')"
                                class="xc-form-item-fixed"
                            >
                                <flat-pickr
                                    v-model="mix_query.startTime"
                                    class="xc-input"
                                    :config="config"
                                    placeholder="请选择时间"
                                    name="startTime"
                                    v-validate="'required'"
                                    data-vv-as="时间"
                                ></flat-pickr>
                                <span>-</span>
                                <flat-pickr
                                    v-model="dayEndTime"
                                    class="xc-input xc-input-disabled"
                                    disabled
                                    :config="config"
                                    placeholder="请选择时间"
                                    name="dayTime"
                                    v-validate="'required'"
                                    data-vv-as="时间"
                                ></flat-pickr>
                            </xc-form-item>
                            <div class="xc-form-inline">
                                <button
                                    type="submit"
                                    class="xc-btn xc-btn-primary"
                                    @click.prevent="mix_search"
                                >查询</button>
                            </div>
                        </template>
                            <div class="xc-form-inline" style="margin-left:10px;" v-if="type != '终端任务发送失败'">
                                <button
                                    type="submit"
                                    class="xc-btn xc-btn-default"
                                    @click.prevent="_export(type)"
                                >导出</button>
                            </div>
                    </div>

                    <!-- 带滚动条的表格 -->
                    <div class="xc-row-scroll">
                        <table class="xc-table">
                            <thead>
                                <th>终端组</th>
                                <th v-if="type == '近期未上线终端' || !isNaN(type)">终端名</th>
                                <th>设备序列号</th>
                                <th>设备MAC</th>
                                <th v-if="type == '七日未上线终端'">最后上线时间</th>
                                <th v-if="type == '终端任务发送失败'">操作说明</th>
                            </thead>
                            <tbody>
                                <template v-if="list && list.length">
                                    <tr
                                        v-for="(item,key) in list"
                                        :key="key"
                                    >
                                        <td>{{item.deviceGroupName}}</td>
                                        <td v-if="type == '近期未上线终端' || !isNaN(type)">{{item.deviceName}}</td>
                                        <td>{{item.deviceSerialNum}}</td>
                                        <td>{{item.deviceMac}}</td>
                                        <td v-if="type == '七日未上线终端'">{{item.lastReportTime}}</td>
                                        <td v-if="type == '终端任务发送失败'">{{item.operation}}</td>
                                    </tr>
                                </template>
                                <template v-else>
                                    <tr>
                                        <td
                                            colspan="9"
                                            class="xc-s-tac"
                                        >暂无数据</td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="xc-modal-footer">
                    <div class="xc-btn-group">
                        <div
                            class="xc-btn xc-btn-default"
                            @click="layerClose"
                        >关闭</div>
                    </div>

                    <xc-pagination
                        @change="mix_pageChange"
                        :page="mix_page"
                        :total="mix_total"
                        :size="mix_pageSize"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import mixin from "../xc-ui/mixins/list";
import homeApi from "../api/home";
import moment from 'moment'

// vee-validate验证
import "@/libs/vee-validate";
import "@/utils/form-format";

// 日期控件
import "@/libs/flatpickr";
import { constants } from "crypto";

export default {
    name: "deviceStateDatail",
    data() {
        return {
            // 列表key
            mix_listKey: "list",

            // 列表唯一字段
            mix_listId: "",

            type: this.$route.query.type,

            // 日期选择
            time: "",
            // https://flatpickr.js.org/options/
            config: {
                // 时间格式
                // dateFormat: "Y-m",
                // 否启用时间选择
                enableTime: false,
                // 选择器中是否可以选择秒
                enableSeconds: false,
                // 用户可以选择的最大日期
                maxDate: ""
            },

            list: [],
            // 默认查询参数
            mix_query: {
                startTime: '',
            },
            dayEndTime: '',
            tag: true
        };
    },

    async created() { },

    mounted() { },

    methods: {
        layerClose() {
            var index = parent.layer.getFrameIndex(window.name);
            parent.layer.close(index);
        },

        // 初始化数据
        async initData() {
            if (this.tag) {
                await this.getNowFormatDate();
            }

            this.tag = false;

            // 默认搜索的数据
            const search = {
                pageNum: this.mix_page,
                pageSize: this.mix_pageSize,
                ...this.mix_query
            };
            if (this.type == "近期未上线终端") {
                homeApi.sevenNotLoginDeviceInfo(search).then(v => {
                    for (let item of v.data.list) {
                        item.lastReportTime = moment(item.lastReportTime).format('YYYY-MM-DD HH:mm:ss')
                    }
                    
                    this.setData(v)
                });
            } else if (this.type == "终端任务发送失败") {
                homeApi.programAddSubFailedInfo(search).then(v => {
                    this.setData(v)
                });
            } else {
                homeApi.getProgramDeviceDetail({
                    type:this.type,
                    ...search
                }).then(v => {
                    this.setData(v);
                })
            }

        },

        setData(v) {
            this.list = this.mix_format(v.data.list);
            this.mix_total = v.data.total;
            this.mix_page = v.data.pageNum;
            this.mix_pageSize = v.data.pageSize;
        },

        _export(key){
            let obj = {
                pageNum: this.mix_page,
                pageSize: this.mix_pageSize,
                ...this.mix_query
            };
            let operation = "";
            let title = "";
            if(!isNaN(key)){
                operation = "exportProgramDeviceDetail";
                if(key == 1){
                    title = "5个节目以下的终端数";
                }else if(key == 2){
                    title = "5-10个节目的终端数";
                }else{
                    title = "10个节目以上的终端数";
                }
            }else{
                operation = "exportSevenNotLoginDeviceInfo";
                title = key;
            }
            homeApi[operation]({
                responseType: 'blob',
                params:obj
            }).then(v => {
                this.$message.success("导出成功");
                let url = window.URL.createObjectURL(new Blob([v]))
                let link = document.createElement('a')
                link.style.display = 'none'
                link.href = url;
                link.setAttribute('download', `${title}.xls`);

                document.body.appendChild(link)
                link.click()
            }).catch(res => {
                console.log(res);
            })
        },

        // 获取前一天日期
        getNowFormatDate() {
            var date = new Date();
            var seperator1 = "-";
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var strDate = date.getDate();
            var data = date.getDate() - 6;
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate;
            }
            var curMonth = year + seperator1 + month;
            var yestodayDate = year + seperator1 + month + seperator1 + data;
            var todayDate = year + seperator1 + month + seperator1 + strDate;
            this.mix_query.startTime = yestodayDate;
            this.dayEndTime = todayDate;
            this.config.maxDate = todayDate;
        }
    },
    mixins: [mixin]
};
</script>

<style lang="scss" scoped>
.xc-modal-footer {
    display: flex;
    align-items: center;
}
.xc-form-item-fixed span {
    padding: 0 8px;
}
</style>

<style lang="scss">
.page-device-statistic {
    .xc-form-item-label {
        min-width: inherit;
    }
    .xc-form-inline .xc-form-item{
        margin-right: 16px;
    }
}
</style>
